import React from 'react';
import { Cake, AlertTriangle } from 'lucide-react';
import { Contract } from '../../../types/contract';
import { ComponentHeader } from './ComponentHeader';

interface ContractHeaderProps {
  contract: Contract;
  statusConfig: {
    label: string;
    color: string;
    bgColor: string;
    borderColor: string;
    icon: React.ComponentType<{ className?: string }>;
  };
  priorityInfo: {
    color: string;
    label: string;
  };
  urgencyAlert: {
    text: string;
    color: string;
  } | null;
}

export const ContractHeader: React.FC<ContractHeaderProps> = ({ 
  contract, 
  statusConfig, 
  priorityInfo, 
  urgencyAlert 
}) => {
  const StatusIcon = statusConfig.icon;
  
  return (
    <div className="group relative">
      {/* Urgency Alert */}
      {urgencyAlert && (
        <div className={`absolute -top-1 left-1/2 transform -translate-x-1/2 z-10 ${urgencyAlert.color} text-white text-xs font-bold px-2 py-0.5 rounded-full shadow-lg flex items-center gap-1`}>
          <AlertTriangle className="w-2.5 h-2.5" />
          {urgencyAlert.text}
        </div>
      )}

      {/* Priority Badge */}
      <div className={`absolute -top-1 -right-1 px-2 py-0.5 bg-gradient-to-r ${priorityInfo.color} shadow-md rounded-full z-10`}>
        <span className="text-white text-xs font-bold">{priorityInfo.label}</span>
      </div>

      <ComponentHeader
        title={contract.contratante?.toUpperCase()}
        subtitle={`Festa de ${contract.nomeAniversariante}`}
        icon={StatusIcon}
      >
        <div className="flex items-center gap-2 text-white/90 mt-2">
          <div className="flex items-center gap-2 min-w-0 flex-1">
            <div className="w-5 h-5 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
              <Cake className="w-3 h-3 text-white" />
            </div>
            <span className="text-lg font-bold text-white truncate min-w-0">
              {contract.nomeAniversariante?.toUpperCase()}
            </span>
            {contract.idadeAniversariante && (
              <span className="px-1.5 py-0.5 bg-white/20 text-white text-xs font-medium rounded-full flex-shrink-0">
                {contract.idadeAniversariante} anos
              </span>
            )}
          </div>
        </div>
      </ComponentHeader>
    </div>
  );
};
